import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { CheckboxProps, useTheme } from '@mui/material';

export interface CheckboxPropsOverride extends CheckboxProps {
    isSelected?: boolean;
}

export const Checkbox = ({ isSelected = false, disabled = false }: CheckboxPropsOverride) => {
    const theme = useTheme();
    return isSelected ? (
        <CheckBoxIcon
            color={disabled ? 'disabled' : undefined}
            sx={{
                fontSize: 16,
                ...(!disabled && { color: theme.palette.semantic.int.checkBox })
            }}
        />
    ) : (
        <CheckBoxOutlineBlankIcon
            color={disabled ? 'disabled' : undefined}
            sx={{
                fontSize: 16,
                ...(!disabled && { color: theme.palette.semantic.icon.subtle })
            }}
        />
    );
};
